/**
 * Navigation-only UI state. Deliberately not localStorage: searches must not
 * survive sign-out/account switching or be written permanently to the browser.
 * Keys include the route and optional explicit-link context. Never store
 * records, selections, or editable forms here.
 */
const values = new Map<string, unknown>();
const listeners = new Set<() => void>();

export const listNavigationState = {
  has: (key: string) => values.has(key),
  get: <T>(key: string) => values.get(key) as T,
  set: <T>(key: string, value: T) => {
    values.set(key, value);
    listeners.forEach(listener => listener());
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};

export function clearListNavigationState() {
  values.clear();
  listeners.forEach(listener => listener());
}
